import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.197 6.39a1.706 1.706 0 0 0-2.394 0 1.65 1.65 0 0 0 0 2.35c.66.653 1.734.653 2.394 0a1.65 1.65 0 0 0 0-2.35m-3.379-.995a3.106 3.106 0 0 1 4.364 0 3.05 3.05 0 0 1 0 4.34 3.106 3.106 0 0 1-4.364 0 3.05 3.05 0 0 1 0-4.34m-.207 7.218c-.675 0-1.211.54-1.211 1.192v.946a.7.7 0 1 1-1.4 0v-.946a2.6 2.6 0 0 1 2.611-2.592h4.778A2.6 2.6 0 0 1 13 13.805v.946a.7.7 0 1 1-1.4 0v-.946c0-.652-.536-1.192-1.211-1.192zM15 7.05a.7.7 0 0 1 .7.7V8.8h1.05a.7.7 0 1 1 0 1.4H15.7v1.05a.7.7 0 1 1-1.4 0V10.2h-1.05a.7.7 0 1 1 0-1.4h1.05V7.75a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=UserWithPlusIcon20.js.map